import fetchServer from "../../../fetchServer";

export default async function proceedOpenTicketWithSupplier(id) {
  let result = {
    return: 0,
    msg: "Failed proceeding open ticket with supplier",
    data: [],
  };

  await fetchServer({
    method: "PATCH",
    url: `/product/v1/changeBooking/proceedOpenTicketWithSupplier/${id}`,
  })
    .then((res) => {
      if (res) {
        if (res.status >= 200 && res.status < 300) {
          result = {
            return: 1,
            msg: res.data?.message || res.data?.data?.message || "Successful",
            data: res.data?.data,
          };
        } else if (res?.data?.error) result.msg = res.data.error;
        else if (res?.data?.message) result.msg = res.data.message;
      }
    })
    .catch((err) => {
      console.log(err.message, err);
      if (err.message === "Network Error!") {
        result.msg = "Network Error!";
        result.error = "Please check your connection.";
      }
    });

  return result;
}
